import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import coverphoto from "../images/roost_banner.png";
import { BrowserView, MobileView, isMobile } from "react-device-detect";
import {
  FaHome,
  FaPhoneAlt,
  FaShoppingCart,
  FaPeopleCarry,
  FaBook,
} from "react-icons/fa";
import { FaGamepad } from "react-icons/fa";
import { TbChristmasTree } from "react-icons/tb";

const mobile = {
  backgroundColor: "#EC2383",
  flex: "display",
  alignItems: "center",
  justifyContent: "center",
};
const web = {
  backgroundColor: "#EC2383",
  flex: "display",
};



function Navigation() {
  const [navbar, setNavbar] = useState(web);
  const [showBar, setShowBar] = useState(true); // State to toggle visibility of the bar

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const hasClosed = localStorage.getItem("roostPopupClosed");
    if (!hasClosed) {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);
  
  const handleClosePopup = () => {
    setShowPopup(false);
    localStorage.setItem("roostPopupClosed", "true");
  };
  
  const handleClickPopup = () => {
    window.location.href = "/shop"; // navigate to /shop on click
  };
  


  useEffect(() => {
    if (isMobile) {
      setNavbar(mobile);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setShowBar(false); // Hide bar if scrolled down
      } else {
        setShowBar(true); // Show bar if at the top
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll); // Cleanup
  }, []);

  const notificationMessage = (
    <div
      style={{
        width: "100%",
        backgroundColor: "#f7c9e5",
        color: "#ed1a84",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >

{showPopup && (
  <div
    onClick={handleClickPopup}
    style={{
      position: "fixed",
      top: "20px",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 9999,
      backgroundColor: "#ed1a84",
      color: "#fff",
      padding: "25px 35px",
      borderRadius: "14px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
      fontFamily: "Gotham, sans-serif",
      fontSize: "20px",
      textAlign: "center",
      maxWidth: "90vw",
      cursor: "pointer",
    }}
  >
    🎉 <b>$0 Copies of Roost (Australia only)</b> Tap here to shop now!
    <button
      onClick={(e) => {
        e.stopPropagation();
        handleClosePopup();
      }}
      style={{
        marginLeft: "20px",
        background: "transparent",
        border: "none",
        color: "#fff",
        fontSize: "22px",
        fontWeight: "bold",
        cursor: "pointer",
      }}
      aria-label="Close popup"
    >
      ✖
    </button>
  </div>
)}



<div
      style={{
        overflow: "hidden",
        whiteSpace: "nowrap",
        position: "relative",
        padding: "5px",
        fontFamily: "Gotham, sans-serif",
        fontSize: "16px",
        top: 0,
        left: 0,
        zIndex: 1100,
        cursor: "pointer",
        width: "100%",
      }}
      onClick={() => (window.location.href = "/shop")}
    >
      <div
        style={{
          display: "inline-block",
          animation: "scrollText 7s linear infinite",
        }}
      >
        <b>Our Christmas Sale:</b> $0 Copies of Roost!
      </div>

      <style>
        {`
          @keyframes scrollText {
            from {
              transform: translateX(100%);
            }
            to {
              transform: translateX(-100%);
            }
          }
        `}
      </style>
    </div>
    </div>
  );
  return (
    <div className="navigation">
      {showBar && notificationMessage}

      <nav className="navbar navbar-expand navbar-dark" style={navbar}>
        <BrowserView>{browserContents()}</BrowserView>
        <MobileView>{mobileContents()}</MobileView>
      </nav>
    </div>
  );
}

export default Navigation;
function mobileContents() {
  return (
    <div>
      <div>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/"
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <FaHome style={{ width: 40 }} />
              <span className="sr-only">(current)</span>
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/rules"
              style={{
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <FaGamepad style={{ width: 40 }} />
              Rules
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/purchase"
              style={{
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <FaPeopleCarry style={{ width: 40 }} />
              Community
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/contact"
              style={{
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <FaPhoneAlt style={{ width: 40 }} />
              Contact
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/supporters"
              style={{
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <FaBook style={{ width: 40 }} />
              About
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/shop"
              style={{
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <FaShoppingCart style={{ width: 40 }} />
              Shop
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}

function browserContents() {
  return (
    <div
      className="container"
      style={{
        alignItems: "center",
        display: "flex",
        width: "100%",
        alignContent: "center",
      }}
    >
      <NavLink className="navbar-brand" to="/">
        <div>
          <img
            className="img-fluid rounded mb-4 mb-lg-0"
            src={coverphoto}
            alt=""
            width={150}
          />
        </div>
      </NavLink>

      <div>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <NavLink className="nav-link" to="/">
              Home
              <span className="sr-only">(current)</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/rules">
              Play
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/purchase">
              Community
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/contact">
              Contact
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/supporters">
              About
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/shop">
              Shop
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}
